import styled from 'styled-components';
export const Root = styled.div `
  position: relative;
  width: 100%;
  height: 45px;
  background-color: #fff;
  font-size: 24px;
  color: #1a1a1a;
  .top--left1 {
      width: 308px;
  }
  .top--btn {
    position: absolute;
    top: 0;
    right: 0;
    height: 45px;
    .ant-btn {
      height: 45px;
      font-size: 18px;
      color: #fff;
    }
    .btn_stop {
      margin-right: 29px;
      background-color: #ff4040;
      border-color: #ff4040;
    }
    .btn_stop.disabled {
      opacity: 0.37;
    }
    .btn_goOn {
      margin-right: 29px;
      background-color: #1dbf6e;
      border-color: #1dbf6e;
    }
    .btn_begin {
      background-color: #1dbf6e;
      border-color: #1dbf6e;
    }
    .btn_end {
      background-color: transparent;
      border: solid 1px #bfbfbf;
      color: #1a1a1a;
    }
    .btn_switchCar {
      margin-left: 29px;
      background-color: transparent;
      border: solid 1px #bfbfbf;
      color: #1a1a1a;
    }
  }
`;
